import { render } from "./customEdge.edge.vue?vue&type=template&id=97432f9e"
import script from "./customEdge.edge.vue?vue&type=script&lang=js"
export * from "./customEdge.edge.vue?vue&type=script&lang=js"

import "./customEdge.edge.vue?vue&type=style&index=0&id=97432f9e&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__